// extracted by mini-css-extract-plugin
module.exports = {"containerDisplay":"StockProvider_containerDisplay__1gWi_","contentDisplay":"StockProvider_contentDisplay__3ufEF","containerBarcode":"StockProvider_containerBarcode__2-sL7"};